export enum CARD_TYPE {
  PLAIN_CARD = 'PLAIN_CARD',
  ANIMATED_CARD = 'ANIMATED_CARD',
  PHOTO_CARD = 'PHOTO_CARD',
  FEATURED_CARD = 'FEATURED_CARD',
}
